import { defineMessages } from 'react-intl';

export const i18n: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	initialDescriptionParameter: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	initialImageAltTextParameter: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	initialTitleParameter: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	title: {
		id: 'company-hub.spotlight-extension.manifest.macro-title',
		defaultMessage: 'Spotlight',
		description:
			'Title of spotlight extension to be displayed in toolbar/shortcut macros dropdown.',
	},
	description: {
		id: 'company-hub.spotlight-extension.manifest.macro-description',
		defaultMessage: 'Highlight messages with a visual spotlight',
		description:
			'Description of spotlight extension to be displayed in toolbar/shortcut macros dropdown',
	},
	initialTitleParameter: {
		id: 'company-hub.spotlight-extension.manifest.initial-state.text-title',
		defaultMessage: 'Give your spotlight a title',
		description:
			'Initial text title parameter of spotlight extension to be displayed in the UI of the editor and view page.',
	},
	initialDescriptionParameter: {
		id: 'company-hub.spotlight-extension.manifest.initial-state.text-description',
		defaultMessage:
			'Design a spotlight to highlight your most vital information. Bring the most important messages to life with custom colors, a powerful image, and flexible layouts.',
		description:
			'Initial description parameter of spotlight extension to be displayed in the UI of the editor and view page.',
	},
	initialImageAltTextParameter: {
		id: 'company-hub.spotlight-extension.manifest.initial-state.alt-image-text',
		defaultMessage: 'Landscape photography of desert',
		description:
			'Initial image alt text parameter of spotlight extension to be displayed in the UI of the editor and view page.',
	},
});
